import { lazy, Suspense } from "react"
import { CenteredBox, PageLoader } from "src/shared/components"
import PosLayout from "src/shared/layouts/pos/pos-layout"
import PrivateRoute from "../private-route"
const POS = lazy(() => import("src/modules/POS"))

const posRoutes = {
  path: "pos/:locationId/:registerId",
  element: (
    <PrivateRoute>
      <Suspense
        fallback={
          <CenteredBox sx={{ height: "100%", position: "relative" }}>
            <PageLoader position="absolute" isLoading height={"100%"} />
          </CenteredBox>
        }
      >
        <PosLayout />
      </Suspense>
    </PrivateRoute>
  ),
  children: [
    {
      index: true,
      element: <POS />
    }
  ]
}

export default posRoutes
